import { Navigate, Route, Routes } from 'react-router-dom';
import { ConsentPage } from '@/pages/enroll/ConsentPage';
import { DataPage } from '@/pages/enroll/DataPage';
import { SelfiePage } from '@/pages/enroll/SelfiePage';
import { SuccessPage } from '@/pages/enroll/SuccessPage';
import { HomePage } from '@/pages/HomePage';
import { RecognizePage } from '@/pages/recognize/RecognizePage';

/**
 * Dois caminhos a partir da home:
 *   /cadastrar → termos → selfie (prova de vida) → dados → sucesso
 *   /reconhecer → captura → resultado (nome + documento mascarado)
 */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/cadastrar" element={<ConsentPage />} />
      <Route path="/cadastrar/selfie" element={<SelfiePage />} />
      <Route path="/cadastrar/dados" element={<DataPage />} />
      <Route path="/cadastrar/sucesso" element={<SuccessPage />} />
      <Route path="/reconhecer" element={<RecognizePage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
